module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deployment_name":"Deployment Name","error":{"namespace_required":"The namespace is required.","namespace_invalid":"It must be at most 32 characters long and only contain letters, numbers, dots, dashes and underscores.","namespace_exists":"Namespace exists"},"notice":{"create":"Create"}}}')
  delete Component.options._Ctor
}
